<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.userClockResult"
        placeholder="考勤状态"
      >
        <el-option
          v-for="(item, i) in trainTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input v-model="filters.userName" placeholder="姓名"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="searchFile"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      trainTypeData: [],
    };
  },
  created() {
    getDataMap("ATTENDANCE_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.trainTypeData = res.data;
    });
  },
  methods: {
    resetData() {
      //重置
      this.filters = {};
      this.searchFile();
    },
    searchFile() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
